import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'

import ROUTES from '../../routes';
import api from '../../config/axiosInstance';

import { showToast } from '../../utils/toast';
import { handleErrors } from '../../utils/common';

function EditAgent() {
    const { id } = useParams();
    const navigate = useNavigate();
    const formRef = useRef();

    const [name, setName] = useState('');
    const [rank, setRank] = useState('');
    const [department, setDepartment] = useState('');
    const [phone, setPhone] = useState('');
    const [whatsApp, setWhatsApp] = useState('');
    const [email, setEmail] = useState('');
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const fetchAgent = async () => {
            try {
                const res = await api.get(`/agent/${id}`);
                if (res.status === 200) {
                    const agent = res.data.agent;
                    setName(agent.name || '');
                    setRank(agent.rank || '');
                    setDepartment(agent.department || '');
                    setPhone(agent.phone || '');
                    setWhatsApp(agent.whatsApp || '');
                    setEmail(agent.email || '');
                    // setImagePreview(agent.image ? `${res.data.base_url}${agent.image}` : null);

                    const imageUrl = agent.image?.startsWith('http')
                        ? agent.image
                        : `${res.data.base_url}${agent.image}`;

                    setImagePreview(agent.image ? imageUrl : null);
                }
            } catch (err) {
                handleErrors(err);
            }
        };

        fetchAgent();

        $.validator.addMethod("dubaiPhone", function (value, element) {
            return this.optional(element) || /^(\+971(50|51|52|53|54|55|56|58|04)\d{7})$/.test(value);
        }, "Please enter a valid Dubai phone number (e.g., +971501234567 or +97141234567).");

        $.validator.addMethod('extension', function (value, element, allowedExtensions) {
            if (!value) return true;
            var extension = value.split('.').pop().toLowerCase();
            return $.inArray(extension, allowedExtensions) !== -1;
        }, 'Only jpg, jpeg, png allowed');


        if (formRef.current && $.fn.validate) {
            $(formRef.current).validate({
                rules: {
                    name: {
                        required: true,
                        minlength: 3
                    },
                    rank: {
                        required: true
                    },
                    department: {
                        required: true
                    },
                    phone: {
                        required: true,
                        dubaiPhone: true
                    },
                    whatsApp: {
                        required: true,
                        dubaiPhone: true
                    },
                    email: {
                        required: true,
                        email: true
                    },
                    image: {
                        required: false,
                        extension: ['jpg', 'jpeg', 'png', 'svg']
                    }
                },
                messages: {
                    name: {
                        required: "Please enter your name",
                        minlength: "Name must be at least 3 characters"
                    },
                    rank: {
                        required: "Please select a rank"
                    },
                    department: {
                        required: "Please enter department"
                    },
                    phone: {
                        required: "Please enter phone number",
                        dubaiPhone: "Please enter a valid Dubai phone number (e.g., +971501234567)."
                    },
                    whatsApp: {
                        required: "Please enter WhatsApp number",
                        dubaiPhone: "Please enter a valid Dubai phone number (e.g., +971501234567)."
                    },
                    email: {
                        required: "Please enter your email",
                        email: "Please enter a valid email"
                    },
                    image: {
                        extension: "Only jpg, jpeg, png allowed"
                    }
                },
                ignore: [],
                errorElement: "label",
                validClass: "is-valid",
                errorClass: "is-invalid text-danger",
                highlight: function (element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).removeClass(errorClass).addClass(validClass);
                }
            });
        }

    }, [id]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleFormSubmit = async () => {

        const $ = window.jQuery;
        const form = $(formRef.current);

        if (form.valid()) {

            setName('');
            setRank('');
            setDepartment('');
            setPhone('');
            setWhatsApp('');
            setEmail('');

            setImage(null);
            setImagePreview(null);

            $(form)
                .find('.is-valid, .is-invalid')
                .removeClass('is-valid is-invalid');

            $(form)
                .find('label.error, .invalid-feedback')
                .remove();

            let payload = {
                name,
                rank,
                department,
                phone,
                whatsApp,
                email,
                image
            };

            try {
                setSubmitting(true);
                const res = await api.put(
                    `/agent/${id}`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );
                if (res.status === 200) {
                    showToast("success", res.data.message, "Success");
                    navigate(ROUTES.AGENTS);
                }
            } catch (err) {
                handleErrors(err);
            }
            finally {
                setSubmitting(false);
            }
        }
    };

    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to={ROUTES.AGENTS}>Agents</Link>
                    </li>
                    <li className="breadcrumb-item active">
                        <Link to={ROUTES.ADD_AGENT}>Edit Agent</Link>
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Edit Agent</h4>
                        </div>
                        <div className="card-body">
                            <form ref={formRef} noValidate>
                                <div className="row">

                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Name</label>
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Elon Mask"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Designation</label>
                                        <input
                                            name="rank"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Director"
                                            value={rank}
                                            onChange={(e) => setRank(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Department</label>
                                        <input
                                            name="department"
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Secondary Sales"
                                            value={department}
                                            onChange={(e) => setDepartment(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Phone</label>
                                        <input
                                            name="phone"
                                            type="text"
                                            className="form-control"
                                            placeholder="+971 50 123 4567"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Whatsapp</label>
                                        <input
                                            name="whatsApp"
                                            type="text"
                                            className="form-control"
                                            placeholder="+971 50 123 4567"
                                            value={whatsApp}
                                            onChange={(e) => setWhatsApp(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-4 col-md-6">
                                        <label className="form-label">Email</label>
                                        <input
                                            name="email"
                                            type="email"
                                            placeholder="Ex. elon.mask@example.com"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3 col-lg-6 col-md-6">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <div className="input-group custom_file_input">
                                            <div className="form-file">
                                                <input
                                                    name="image"
                                                    type="file"
                                                    className="form-file-input form-control"
                                                    onChange={handleImageChange}
                                                />
                                            </div>
                                            <span className="input-group-text">Upload</span>
                                        </div>
                                        {imagePreview && (
                                            <div className="mt-2">
                                                <img
                                                    src={imagePreview}
                                                    alt="Preview"
                                                    style={{ width: 100, height: 100, objectFit: 'cover' }}
                                                />
                                            </div>
                                        )}
                                    </div>

                                </div>

                                <div className="pt-3">
                                    <button
                                        type="button"
                                        onClick={handleFormSubmit}
                                        className="btn btn-sm btn-primary me-2"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <i className="spinner-border spinner-border-sm me-1"></i>
                                                Submit
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-floppy-disk me-1"></i>
                                                Submit
                                            </>
                                        )}
                                    </button>
                                    <Link to={ROUTES.AGENTS} className="btn btn-sm btn-danger light">
                                        <i className="fas fa-times-circle"></i>&nbsp;
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditAgent
